import {SelectChangeEvent, SelectProps} from '@mui/material/Select'
import * as React from 'react'
import {ReactNode} from 'react'
import {withErrorSubscribe} from './hoc/withErrorSubscribe'
import {ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import FormErrorMessage from './FormErrorMessage'
import {withHint} from './hoc/withHintButton'
import {LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import styled from 'styled-components'
import {AppAdminContext} from '../../../app/AppAdminContext'

import { Select } from '@mui/material';

export interface OptionProps {
    label: string
    value: string
}

interface Props {
    data: OptionProps[]
}

interface State {
    selectedLabel: string
}

const SelectWithHint = withHint(Select)

class PPSelect
    extends React.Component<SelectProps & Props & ErrorHandlingFormProps, State> {

    declare context: React.ContextType<typeof AppAdminContext>

    static displayName: string = 'PPSelect'

    constructor(props: Readonly<SelectProps & Props & ErrorHandlingFormProps>) {
        super(props)
        this.state = {
            selectedLabel: '',
        }
        this.handleChange = this.handleChange.bind(this)
    }

    findSelectedLabel(value: string): string {
        let label: string = ''
        this.props.data.forEach((option) => {
            if (option.value === (value)) {
                label = option.label
                return
            }
        })
        return label
    }

    handleChange(
        event: SelectChangeEvent<unknown>,
        child: React.ReactNode,
    ): void {
        this.setState({
            selectedLabel: this.findSelectedLabel(event.target.value as string),
        })
        if (this.props.clearErrorMessage) {
            this.props.clearErrorMessage()
        }
        if (this.props.onChange) {
            this.props.onChange(event, child)
        }
    }

    render(): ReactNode {
        const {
            variant,
            hasError,
            data, eventKeys, eventEmitter,
            clearErrorMessage,
            ...rest
        } = this.props
        const spMode = this.context.showSpModePage

        return <>
            <LeftColumnFlexContainer className={'withErrorMessage'}>
                <StyledSelectWithHint
                    {...rest}
                    $spMode={!variant && spMode}
                    variant={variant ?? (spMode ? 'outlined' : 'standard')}
                    error={hasError}
                    native
                    onChange={this.handleChange}
                >
                    {
                        data.map((item) => {
                            return (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>)
                        })
                    }
                </StyledSelectWithHint>
                {
                    this.props.messages &&
                    <FormErrorMessage
                        messages={this.props.messages.map((pair) => {
                            return {
                                message: pair.message,
                                params: [this.state.selectedLabel],
                            }
                        })}
                    />
                }
            </LeftColumnFlexContainer>
        </>
    }
}

PPSelect.contextType = AppAdminContext
export default withErrorSubscribe(PPSelect)

const StyledSelectWithHint = styled(SelectWithHint)<{ $spMode: boolean }>`
  ${props => props.$spMode && `
  .MuiInputBase-input {
    padding: 15px 32px 15px 3px;
  }
  `};

 @media all and (-ms-high-contrast: none) {
   select {
      height: 100%;
   }
 }`
;
